// extracted by css-extract-rspack-plugin
export default {"root":"root-f77l1T","s":"s-qJ5xLR"};